import { Identify, identify as amplitudeIdentify, init as amplitudeInit } from '@amplitude/analytics-browser';
import { Config, isClientEnvironment, isDevEnvironment, isStgEnvironment } from '@core/configuration';
import { LicenseSelectors } from '@core/license';
import { ProjectLocalStorage } from '@core/projects';
import Registry from '@core/registry';
import md5 from 'md5';
import { AmplitudeConstant } from '../constants/AmplitudeConstant.js';
import { Store } from '../store/Store.js';
var chainProperties = function chainProperties(properties) {
    var chain = new Identify();
    for(var key in properties){
        if (properties.hasOwnProperty(key)) {
            chain = key === 'projectId' && !properties[key] ? chain.unset(key) : chain.set(key, properties[key]);
        }
    }
    return chain;
};
var isTrial = function isTrial() {
    return LicenseSelectors.isTrialLicense(Store.getState());
};
var getProductName = function getProductName() {
    return LicenseSelectors.getProductName(Store.getState());
};
var getProductType = function getProductType() {
    return LicenseSelectors.getProductType(Store.getState());
};
var getProductEdition = function getProductEdition() {
    return LicenseSelectors.getProductEdition(Store.getState());
};
var getSelectedProjectId = function getSelectedProjectId() {
    return ProjectLocalStorage.getProjectId();
};
var getUserContext = function getUserContext() {
    var user = Registry.get('userModel');
    return {
        appVersion: __APP_VERSION__,
        userId: user.email,
        SSO: user.provider.toLowerCase(),
        isInternalUser: user.email.includes('@coveo.com'),
        platformRegion: Config.CloudPlatform.region,
        organizationId: Registry.get('organization_id'),
        productName: getProductName(),
        productType: getProductType(),
        productEdition: getProductEdition(),
        projectId: getSelectedProjectId()
    };
};
/**
 * Identification to the tracking platform.
 *
 * @param {"commerce-hub" | "knowledge-hub" | "platform"} ['platform'] currentApp
 */ export var identify = function identify() {
    var currentApp = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'platform';
    var userContext;
    try {
        userContext = getUserContext();
    } catch (unused) {
        return;
    }
    if (userContext.userId.endsWith('@devcoveo.onmicrosoft.com')) {
        return;
    }
    var apiKey = AmplitudeConstant.apiKey.platformDev;
    if (isClientEnvironment()) {
        apiKey = isTrial() ? AmplitudeConstant.apiKey.platformProductionTrials : AmplitudeConstant.apiKey.platformProduction;
    }
    var hashedUserId = md5(userContext.userId);
    if (!isTrial() && !userContext.isInternalUser) {
        userContext.userId = hashedUserId;
    }
    userContext.viewportWidth = window.innerWidth;
    userContext.viewportHeight = window.innerHeight;
    userContext.screenResolutionWidth = screen.width;
    userContext.screenResolutionHeight = screen.height;
    userContext.coveoApp = currentApp;
    // @todo: [CTCORE-9515] should the `appVersion` attribute be filled in with the AdminUI project version.
    try {
        amplitudeInit(apiKey, hashedUserId, {
            autocapture: false,
            identityStorage: 'localStorage',
            serverUrl: isDevEnvironment() || isStgEnvironment() ? AmplitudeConstant.devEndpoints[Config.env] : AmplitudeConstant.productionEndpoints[Config.CloudPlatform.region],
            trackingOptions: {
                ipAddress: false
            }
        });
    } catch (error) {
        console.error('Failed to initialize Amplitude:', error);
        return;
    }
    try {
        amplitudeIdentify(chainProperties(userContext));
    } catch (error) {
        console.error('Failed to identify user in Amplitude:', error);
    }
};

//# sourceMappingURL=identify.js.map